import { TransformNS } from "../../../../../../Transform/TransformNS.js";
export const _handleMouseDownOnSelectorScaleNECircleEl = (self, event) => {
  const selector_sw_circle_el = self._getSelectorSWCircleElThrowable();
  const selector_se_circle_el = self._getSelectorSECircleElThrowable();
  const selector_nw_circle_el = self._getSelectorNWCircleElThrowable();
  self._handleMouseDownOnSelectorScaleCircleEl({
    event,
    origin_circle_el: selector_sw_circle_el,
    x_axis_circle_el: selector_se_circle_el,
    y_axis_circle_el: selector_nw_circle_el,
    scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
  });
};
